<template>
  <v-toolbar
    v-if="$store.state.isUserLoggedIn"
    id="core-toolbar"
    app
    flat
    prominent
    style="background: #eee;"
  >
    <!-- <v-alert
      :to="'/Configuracion'"
      v-model="alert"
      dismissible
      type="info"
      v-if="$store.state.proDevices"
    >
      Configuración de alertas para AgroBot Pro, AgroBot Light y AgroBot Soil
      disponible!
    </v-alert> -->
    <div class="v-toolbar-title">
      <v-toolbar-title class="tertiary--text font-weight-light">
        <v-btn
          v-if="responsive"
          class="default v-btn--simple"
          dark
          icon
          @click.stop="onClickBtn"
        >
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        <!-- {{ title }} -->
      </v-toolbar-title>
    </div>

    <v-spacer />
    <div v-show="$store.state.userId != 22">
      <v-layout>
        <v-select
          v-show="$store.state.userType == 'admin'"
          id="companyId"
          class="dropdown"
          v-model="companyId"
          :items="$store.state.companies"
          item-text="name"
          item-value="id"
          label="Compañia"
          @input="selectCompany(companyId)"
        />
        <v-select
          v-model="project"
          :items="$store.state.projectsArr"
          label="Proyecto"
          @input="selectProject(project)"
        />

        <v-select
          v-if="$store.state.project"
          v-model="selectSub"
          :items="$store.state.subProjectsArr"
          name="name"
          item-text="name"
          label="Rancho"
          @change="selectSubProject($event)"
        />
      </v-layout>
    </div>

    <v-toolbar-items>
      <v-flex align-center layout py-2>
        <v-menu
          v-if="this.$store.state.subProject !== null"
          bottom
          left
          content-class="dropdown-menu"
          offset-y
          transition="slide-y-transition"
        >
          <router-link
            v-ripple
            slot="activator"
            class="toolbar-items"
            to="/Notificaciones"
          >
            <v-badge color="error" overlap>
              <template slot="badge" v-if="this.$store.state.alerts.length > 0">
                {{ this.$store.state.alerts.length }}
              </template>
              <v-icon color="tertiary">mdi-bell</v-icon>
            </v-badge>
          </router-link>
          <v-card>
            <v-list dense>
              <v-list-tile
                v-for="notification in notifications"
                :key="notification"
                @click="onClick"
              >
                <v-list-tile-title v-text="notification" />
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
      </v-flex>
    </v-toolbar-items>

    <v-snackbar
      v-if="$store.state.userId != 22"
      v-model="snackbar"
      :multi-line="true"
      :timeout="timeout"
      :top="true"
      :right="true"
      :vertical="true"
    >
      {{ text }}
      <v-btn color="pink" flat @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-toolbar>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import moment from "moment-timezone";

export default {
  data: () => ({
    alert: true,
    total: 0,
    snackbar: true,
    text: "Recuerda seleccionar proyecto y rancho ^",
    timeout: 3000,
    select: null,
    selectSub: null,
    devices: null,
    notifications: [],
    title: null,
    responsive: false,
    initial: null,
    alertIcon: false,
    companyId: null,
  }),
  computed: {
    ...mapGetters({
      nameFromStore: "project",
      // nameFromStore: 'devices'
    }),
    project: {
      get() {
        return this.$store.state.project;
      },
      set(value) {
        this.$store.commit("project", value);
      },
    },
  },
  watch: {
    $route(val) {
      this.title = val.name;
    },
  },
  beforeUpdate() {
    if (this.$store.state.userId == 22) {
      // alert("MOUNTED");
      this.selectProjectDemo();
      this.selectSubProjectDemo("Andromeda");
    }
  },

  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);

    // if (this.$store.state.userId == 22) {
    //   alert("MOUNTED");
    //   this.selectProject("BlueDrop Berries");
    //   this.selectSubProject("Andromeda");
    // }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    selectCompany(companyId) {
      // let id = this.$store.state.projects.find((x) => x.name === project).id;
      this.$store.dispatch("getProjectsArr", companyId);
      // alert(companyId);
    },
    selectProject(project) {
      let id = this.$store.state.projects.find((x) => x.name === project).id;
      this.$store.dispatch("getSubProjectsArr", id);
    },
    selectProjectDemo() {
      let id = 1;
      this.$store.dispatch("getSubProjectsArr", id);
    },
    selectSubProject(event) {
      // this.notifications = null
      if (this.$store.state.subProjectsArr != null) {
        let id = this.$store.state.subProjectsArr.find((x) => x.name === event)
          .id;

        let payload = {
          subProjectId: id,
          startDate: moment(new Date()).format("YYYY-MM-DD"),
          endDate: moment()
            .add(1, "days")
            .format("YYYY-MM-DD"),
        };

        this.$store.commit("subProject", event);

        this.$store.commit("subProjectId", id);
        this.$store.dispatch("getTable", event);
        this.$store.dispatch("getDevicesArr", id);
        this.$store.dispatch("getAgroUnits", id);
        this.$store.dispatch("getAgroUnitsOld", id);
        this.$store.dispatch("getIrrigationInstructions", payload);

        this.$store.dispatch("getAlerts", id);
        this.$store.dispatch("getAlertsResolved", id);
      }
    },
    selectSubProjectDemo(event) {
      let id = 1;
      let payload = {
        subProjectId: id,
        startDate: moment(new Date()).format("YYYY-MM-DD"),
        endDate: moment()
          .add(1, "days")
          .format("YYYY-MM-DD"),
      };

      this.$store.commit("subProject", event);
      this.$store.commit("subProjectId", id);
      this.$store.dispatch("getTable", event);
      this.$store.dispatch("getDevicesArr", id);
      this.$store.dispatch("getAgroUnits", id);
      this.$store.dispatch("getAgroUnitsOld", id);
      this.$store.dispatch("getIrrigationInstructions", payload);
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  },
};
</script>

<style>
#core-toolbar a {
  text-decoration: none;
}
</style>
